import React, { FC } from 'react';
import { useLocale } from '@app/core/hooks/useLocale';
import styles from './input-summary.module.scss';
import MinusIcon from '@app/shared/icons/MinusIcon';
import SvgPlus from '@app/shared/icons/Plus';
import CellValue from '@app/shared/components/cell-value/CellValue';
import { amountRules } from '@app/shared/components/cell-value/CellValueConfigurations';
import { yearFormatter } from '@app/shared/formatters';

interface InputSummaryNetChangeInCapitalSectionProps {
  filteredEvents: Dictionary<number>;
  show: boolean | undefined;
  showExpander: boolean;
  showAll: boolean;
  setShowAll: (value: boolean) => void;
}

export const InputSummaryNetChangeInCapitalSection: FC<
  InputSummaryNetChangeInCapitalSectionProps
> = ({ filteredEvents, show, showExpander, showAll, setShowAll }) => {
  const { l } = useLocale();

  if (!show) {
    return null;
  }

  return (
    <>
      <tr>
        <th className={styles['title']} data-testid="change-in-capital-header">
          {l('_NetChangeInCapital')}
        </th>
      </tr>
      {Object.entries(filteredEvents)
        .slice(0, showAll ? undefined : 2)
        .map(([key, value], index) => (
          <React.Fragment key={`fragment-${index}`}>
            <tr key={`change-in-capital-event-${index}`}>
              <td className={`${styles['title']} ${styles['net-change-in-capital-primary-light']}`}>
                {yearFormatter(key)}
              </td>
              <td data-testid={`change-in-capital-event-${index}`}>
                <CellValue value={value} className={`${styles['value']}`} {...amountRules} />
              </td>
            </tr>
            {index === 1 && showExpander && (
              <div className={styles['expander']}>
                <button
                  aria-label={l('_ToggleSectionCollapse', {
                    section: l('_NetChangeInCapital'),
                  })}
                  aria-expanded={showAll}
                  onClick={() => setShowAll(!showAll)}
                  className={styles['expander-button']}
                  data-testid="expander-button-event">
                  {showAll ? (
                    <MinusIcon data-testid="minus-icon-event" />
                  ) : (
                    <SvgPlus data-testid="svg-plus-event" />
                  )}
                </button>
              </div>
            )}
          </React.Fragment>
        ))}
    </>
  );
};
